import { FC } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageTitle } from '_metronic/layout/core'
import ConfigRoutes from '../../routing/ConfigRoutes'
import { TenDashboardMain } from './components/TenDashboardMain'
import { TenDashboardResults } from './TenDashboardResults'

const breadcrumbs = [
    {
        title: 'Modules',
        path: '#',
        isSeparator: false,
        isActive: false,
    },
    {
        title: 'TEN Dashboard',
        path: ConfigRoutes.admin.tenDashboard?.principal || '#',
        isSeparator: true,
        isActive: true,
    },
]

const TenDashboardWrapper: FC = () => {
    return (
        <>
            <Routes>
                <Route
                    element={
                        <>
                            <PageTitle breadcrumbs={breadcrumbs}>TEN Dashboard</PageTitle>
                            <TenDashboardMain />
                        </>
                    }
                >
                    <Route index element={<Navigate to={ConfigRoutes.admin.tenDashboard?.base || '/ten-dashboard'} />} />
                </Route>
                <Route
                    path="results"
                    element={<TenDashboardResults />}
                />
            </Routes>
        </>
    )
}

export { TenDashboardWrapper }
